/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".account-user-modal *{-webkit-box-sizing:border-box;box-sizing:border-box;text-align:left}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/account.users/account.users.modal.component.scss.ngstyle.js.pre-build-optimizer.js